import { ExameConfiance } from 'app/core/interfaces/pacient-info.interface';

export function buildDateAtT03UTC(year: number, month: number, day: number): string {
  const yyyy = year.toString().padStart(4, '0');
  const mm = month.toString().padStart(2, '0');
  const dd = day.toString().padStart(2, '0');

  return `${yyyy}-${mm}-${dd}T03:00:00.000Z`;
}

export function normalizeDateToT03UTC(data: any): string | null {
  if (!data) return null;

  if (typeof data === 'string') {
    if (data.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(data)) {
      return buildDateAtT03UTC(
        parseInt(data.slice(0, 4), 10),
        parseInt(data.slice(5, 7), 10),
        parseInt(data.slice(8, 10), 10)
      );
    }

    const parsed = new Date(data);
    if (!isNaN(parsed.getTime())) {
      return normalizeDateToT03UTC(parsed);
    }

    return null;
  }

  if (data instanceof Date) {
    if (isNaN(data.getTime())) return null;

    return buildDateAtT03UTC(data.getFullYear(), data.getMonth() + 1, data.getDate());
  }

  if (typeof data === 'object') {
    if (typeof data.toDate === 'function') {
      return normalizeDateToT03UTC(data.toDate());
    }

    const seconds = typeof data.seconds === 'number'
      ? data.seconds
      : typeof data._seconds === 'number'
        ? data._seconds
        : null;

    if (seconds !== null) {
      return normalizeDateToT03UTC(new Date(seconds * 1000));
    }
  }

  return null;
}

export function getDateFromResultados(examesAnalisados: ExameConfiance[]): string | null {
  if (!Array.isArray(examesAnalisados) || examesAnalisados.length === 0) {
    return null;
  }

  const exameComData = examesAnalisados.find(item => !!item.data);
  const rawDate = exameComData ? exameComData.data : null;
  if (!rawDate) {
    return null;
  }

  if (/^\d{4}-\d{2}-\d{2}/.test(rawDate)) {
    return buildDateAtT03UTC(
      parseInt(rawDate.slice(0, 4), 10),
      parseInt(rawDate.slice(5, 7), 10),
      parseInt(rawDate.slice(8, 10), 10)
    );
  }

  const ddmmyyyy = rawDate.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (ddmmyyyy) {
    const [, dd, mm, yyyy] = ddmmyyyy;
    return buildDateAtT03UTC(parseInt(yyyy, 10), parseInt(mm, 10), parseInt(dd, 10));
  }

  return normalizeDateToT03UTC(rawDate);
}

export function resolveLaboratorioDataPadrao(
  dataRealizacaoArquivo: any,
  examesAnalisados: ExameConfiance[]
): string {
  const dataRealizacaoNormalizada = normalizeDateToT03UTC(dataRealizacaoArquivo);
  if (dataRealizacaoNormalizada) return dataRealizacaoNormalizada;

  const dataResultado = getDateFromResultados(examesAnalisados);
  if (dataResultado) return dataResultado;

  return normalizeDateToT03UTC(new Date()) as string;
}
